export interface EnumVariant {
  description?: string;
  id?: number;
  /** Stable key for this variant, unique within its parent definition. Prefer it over `id`. */
  identifier?: string;
  name?: string;
  variant_name?: string;
  state?: 'active' | 'deprecated' | 'disabled';
}

export enum TagState {
  Active = 'active',
  Deprecated = 'deprecated',
  Disabled = 'disabled',
}

/**
 * Used to represent questions for events
 */
export interface Tag {
  description: string;
  name: string;
  value_type: 'int' | 'bool' | 'enum';
  is_rare: boolean;
  is_internal: boolean;
  is_global: boolean;
  fleet_uuids?: string[];
  enum_variants?: EnumVariant[];
  id?: any;
  /** Stable key for this definition, unique across all definitions. Prefer it over `id`, which is environment-specific. */
  identifier?: string;
  max_value?: number;
  min_value?: number;
  state?: TagState;
}

/**
 * Used to store answers for events
 */
export interface Tags {
  [key: string]: string | number | boolean;
}
